import Sources from "./Sources";

const TrainingPage = () => {
  return (
    <section className="leading-relaxed max-w-screen-xl mt-12 mx-auto px-4 lg:px-8">
      <div className="space-y-3 text-center">
        <h1 className="text-3xl text-gray-800 font-semibold">
          نمونه سوالات آمار و احتمال مهندسی
        </h1>
      </div>
      <div className="mt-14 text-center text-gray-300">
        <Sources />
      </div>
    </section>
  );
};
export default TrainingPage;
